// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SibebarMenu_sidebar__30DXc","hidden":"SibebarMenu_hidden__Er3ci"};